// Custom config for pixi.js using only the needed libraries to prevent bundling the entire 1.4mb of the library
// Generated using: https://pixijs.io/customize/
export * from '@pixi/constants';
export * from '@pixi/math';
export * from '@pixi/runner';
export * from '@pixi/settings';
export * from '@pixi/ticker';
import * as utils from '@pixi/utils';
export { utils };
export * from '@pixi/display';
export * from '@pixi/core';
export * from '@pixi/sprite';
export * from '@pixi/app';

// Renderer plugins
import { extensions } from '@pixi/core';
import { BatchRenderer } from '@pixi/core';
extensions.add(BatchRenderer);

// Application plugins
import { Application } from '@pixi/app';
import { TickerPlugin } from '@pixi/ticker';
extensions.add(TickerPlugin);

// Filters
import { DisplacementFilter } from '@pixi/filter-displacement';
export const filters = {
  DisplacementFilter
};
